import React from "react";
import { ModuleI, LessonI } from "../types";
import FadingBar from "../componentLibrary/FadingBar";
import { ProgressRef } from "./Progress";

interface LessonTopNavigationProps {
  module: ModuleI;
  lesson: LessonI;
  currentPage: number;
  totalPages: number;
  progressRef: React.RefObject<ProgressRef>;
  onLearnClick: () => void;
  onExploreClick: () => void;
}

const LessonTopNavigation: React.FC<LessonTopNavigationProps> = ({
  module,
  lesson,
  currentPage,
  totalPages,
  progressRef,
  onLearnClick,
  onExploreClick,
}) => {
  return (
    <FadingBar position="top" className="bg-white shadow-sm">
      <div className="w-full max-w-none px-4 py-3">
        <div className="flex items-center justify-center max-w-3xl mx-auto">
          <div className="flex items-center text-sm sm:text-base text-gray-700 flex-wrap gap-1 justify-center">
            <span
              className="cursor-pointer hover:text-electrum transition-colors underline"
              onClick={onExploreClick}
            >
              Explore
            </span>
            <span className="text-gray-400">›</span>
            <span
              className="cursor-pointer hover:text-electrum transition-colors underline"
              onClick={onLearnClick}
            >
              {module.title}
            </span>
            <span className="text-gray-400">›</span>
            <span
              className="cursor-pointer hover:text-electrum transition-colors underline font-semibold"
              onClick={() => progressRef.current?.openModal()}
            >
              {lesson.title}
            </span>
            <span className="text-gray-500 ml-1">
              ({currentPage + 1}/{totalPages})
            </span>
          </div>
        </div>
      </div>
    </FadingBar>
  );
};

export default LessonTopNavigation;
